// Styles
import './template-collection.scss';
import { throttle } from '../../scripts/helpers';
import { breakpoints } from '../../scripts/components/mediaQueries';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateCollection = (context) => {
  const selectors = {
    backToTop: '[data-back-to-top]'
  };

  const templateCollectionSection = context.closest('.shopify-section');
  if (!templateCollectionSection) return;

  // Manage filters drawer opening/closing
  const filtersOpener = templateCollectionSection.querySelector('.collection-header__main__filters-opener');
  const filtersContainer = templateCollectionSection.querySelector('.filters__container');
  const filterClose = templateCollectionSection.querySelector('.filters-drawer__close');
  if (filtersOpener && filtersContainer) {
    filtersOpener.addEventListener('click', function () {
      filtersContainer.classList.add('open');
      document.querySelector('html').style.overflow = 'hidden';
    });

    if (filterClose) {
      filterClose.addEventListener('click', () => {
        filtersContainer.classList.remove('open');
        document.querySelector('html').style.overflow = '';
      });
    }

    var closeOnMouseUp = false;
    filtersContainer.addEventListener('mousedown', (e) => {
      if (!filtersContainer.classList.contains('open') || e.target.classList.contains('filters-drawer__content') || e.target.closest('.filters-drawer__content')) return;
      closeOnMouseUp = true;
    });

    filtersContainer.addEventListener('mouseup', (e) => {
      if (closeOnMouseUp) {
        filtersContainer.classList.remove('open');
        document.querySelector('html').style.overflow = '';
        closeOnMouseUp = false;
      }
    });
  }

  // Manage active filters' tags
  const activeFilters = templateCollectionSection.querySelector('#FacetFiltersForm .filters-drawer__active-filters');
  activeFilters.querySelectorAll('.filters-drawer__active-filters__filter').forEach(activeLabel => {
    activeLabel.addEventListener('click', function () {
      activeLabel.style.display = 'none';
    });
  });

  templateCollectionSection.querySelectorAll('#FacetFiltersForm .js-filter input[type="checkbox"]').forEach(checkbox => {
    const activeLabel = activeFilters.querySelector(`label[for="${checkbox.id}"]`);

    checkbox.addEventListener('change', function () {
      if (activeLabel) {
        if (checkbox.checked) {
          activeLabel.style.display = '';
        } else {
          activeLabel.style.display = 'none';
        }
      }

      const filterContainer = checkbox.closest('[data-filter]');
      if (filterContainer) {
        const counterLabels = document.querySelectorAll(`#FacetFiltersForm [data-filter="${filterContainer.dataset.filter}"] [single-filter-active-counter]`);
        const checkedCounters = filterContainer.querySelectorAll('input[type="checkbox"]:checked').length;

        if (counterLabels.length > 0) {
          counterLabels.forEach(counterLabel => {
            counterLabel.innerText = `( ${checkedCounters} )`;

            if (checkedCounters <= 0) {
              counterLabel.style.display = 'none';
            } else {
              counterLabel.style.display = '';
            }
          });
        }
      }

      const generalCounter = document.querySelector('.collection-header__main__filters-opener [active-filters-counter]');
      if (generalCounter) {
        const activeFilters = document.querySelectorAll('#FacetFiltersForm .js-filter input[type="checkbox"]:checked').length;
        generalCounter.innerText = `( ${activeFilters} )`;
        if (activeFilters <= 0) {
          generalCounter.style.display = 'none';
        } else {
          generalCounter.style.display = '';
        }
      }
    });
  });

  // Manage filters removal

  const applyFilters = document.querySelector('.collection-filters__filter-drawer__btn--apply');
  const removeFilters = document.querySelector('.collection-filters__filter-drawer__btn--remove');
  removeFilters.addEventListener('click', () => {
    const selectedFilters = document.querySelectorAll('#FacetFiltersForm .js-filter input[type="checkbox"]:checked');
    if (selectedFilters.length > 0) {
      selectedFilters.forEach(checkbox => {
        checkbox.checked = false;

        const activeLabel = templateCollectionSection.querySelector(`label.filters-drawer__active-filters__filter[for="${checkbox.id}"]`);
        activeLabel.style.display = 'none';
      });

      const filterContainer = removeFilters.closest('[data-filter]');
      if (filterContainer) {
        const counterLabels = document.querySelectorAll(`#FacetFiltersForm [data-filter="${filterContainer.dataset.filter}"] [single-filter-active-counter]`);
        if (counterLabels.length > 0) {
          counterLabels.forEach(counterLabel => {
            counterLabel.innerText = '( 0 )';
            counterLabel.style.display = 'none';
          });
        }

        const generalCounter = document.querySelector('#FacetFiltersForm [active-filters-counter]');
        if (generalCounter) {
          const activeFilters = document.querySelectorAll('#FacetFiltersForm .js-filter input[type="checkbox"]:checked').length;
          generalCounter.innerText = `( ${activeFilters} )`;
          if (activeFilters <= 0) {
            generalCounter.style.display = 'none';
          } else {
            generalCounter.style.display = '';
          }
        }
      }

      applyFilters.click();
    }
  });


  $('#CollectionSection .collection-extra-section__opener').each(function () {
    $(this).on('click', function (event) {
      MicroModal.show('modal-collection-extra', {
        disableScroll: true,
      });

      const link = $(this).attr('popup-link');
      $("#CollectionSection .collection-extra__popup")
        .load(link + " #PageContainer .main-content > div", function () {
          $(this).removeClass('spin');
        });
      event.preventDefault();
    });
  });

  const updateBackToTop = () => {
    if (window.innerWidth > breakpoints.md) return;

    if (window.scrollY > window.innerHeight) {
      document.documentElement.classList.add('btt--show');
    } else {
      document.documentElement.classList.remove('btt--show');
    }
  };

  const backToTop = document.querySelector(selectors.backToTop);

  if (backToTop) {
    document.addEventListener('scroll', throttle(updateBackToTop, 200));
    backToTop.addEventListener('click', () => window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    }));
  }

  updateBackToTop();
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('#CollectionSection'), (el) => {
    window.dAgency.initTemplateCollection(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('#CollectionSection'), (el) => {
      window.dAgency.initTemplateCollection(el);
    });
  });
}
